var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28b778"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cfdac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(0.209 -0.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4148",
    "data-name": "Group 4148",
    transform: "translate(-0.209 0.217)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(0 0)",
    fill: "#c9ffe7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4150",
    "data-name": "Group 4150",
    transform: "translate(7.041 7.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4149",
    "data-name": "Group 4149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3008",
    "data-name": "Path 3008",
    d: "M125.369,116.111h-3.7a1.854,1.854,0,0,0-1.852,1.852v2.469a1.854,1.854,0,0,0,1.852,1.852h3.7a.617.617,0,0,0,.617-.617v-4.938A.617.617,0,0,0,125.369,116.111Zm-2.469,3.7a.617.617,0,1,1,.617-.617A.617.617,0,0,1,122.9,119.814Zm-3.086-14.2A.617.617,0,0,0,119.2,105h-9.876a.617.617,0,0,0-.617.617v5.555h11.111Zm-5.555,4.321a.617.617,0,1,1,.617-.617A.617.617,0,0,1,114.259,109.938Zm3.086-.617a.617.617,0,0,1-1.234,0V108.6a1.861,1.861,0,0,1-1.129-1.129h-1.446a1.861,1.861,0,0,1-1.129,1.129v.723a.617.617,0,0,1-1.235,0v-1.235a.617.617,0,0,1,.617-.617.618.618,0,0,0,.617-.617.617.617,0,0,1,.617-.617h2.469a.617.617,0,0,1,.617.617.618.618,0,0,0,.617.617.617.617,0,0,1,.617.617v1.235Zm1.235,11.111v-2.469a3.09,3.09,0,0,1,3.086-3.086h3.086v-1.852a.617.617,0,0,0-.617-.617H106.852A1.854,1.854,0,0,0,105,114.259v9.876a1.854,1.854,0,0,0,1.852,1.852h17.283a.617.617,0,0,0,.617-.617v-1.852h-3.086A3.09,3.09,0,0,1,118.58,120.431Z",
    transform: "translate(-105 -105)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.81e2835e1bf1766b4c6565ce2a546ad4.svg";
export { ForwardRef as ReactComponent };